import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import GroupRemoveRoundedIcon from '@mui/icons-material/GroupRemoveRounded'
import { LoadingButton } from '@mui/lab'

import { useLeaveNetworkMutation } from '@/core/services/network'

import { getApiErrorMessage } from '@/utils/errors'

export default function LeaveNetworkButton({ networkId }: { networkId: string }) {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [leaveNetwork, { isLoading }] = useLeaveNetworkMutation()

  return (
    <LoadingButton
      loading={isLoading}
      startIcon={<GroupRemoveRoundedIcon />}
      onClick={async () => {
        try {
          await leaveNetwork(networkId).unwrap()
        } catch (error) {
          enqueueSnackbar(getApiErrorMessage(error, t('notification.network.join.error')), { variant: 'error' })
        }
      }}
      variant="contained"
    >
      {t('common:button.leave.label')}
    </LoadingButton>
  )
}
